//src/pages/admin/tabs/LeadsTab.jsx

import React from 'react';
import { AdminAPI } from '../../../api/admin';
import { Card, Row3, Field, Btn, TableWrap, Table, Row2 } from '../ui';

const typeLabels = {
  'consultation': 'Консультация',
  'callback': 'Запрос контакта',
  'sell-or-rent': 'Сдача', // дефолт для смешанного типа
};

function displayTypeLabel(leadType, currentFilterType){
  if (leadType === 'sell-or-rent') {
    if (currentFilterType === 'sell') return 'Продать';
    if (currentFilterType === 'rent') return 'Сдача';
    return 'Сдача';
  }
  return typeLabels[leadType] || leadType;
}

const statusLabels = {
  'new': 'Новый',
  'in_progress': 'В работе',
  'done': 'Завершён',
  'rejected': 'Отклонён',
};

function formatDate(d) {
  if (!d) return '—';
  try {
    const dt = new Date(d);
    return dt.toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return String(d);
  }
}

export default function LeadsTab(){
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState('');
  const [status, setStatus] = React.useState('');
  const [type, setType] = React.useState('');
  const [selectedId, setSelectedId] = React.useState(null);
  const [detail, setDetail] = React.useState(null);
  const [loadingDetail, setLoadingDetail] = React.useState(false);

  const load = async () => {
    setLoading(true); setErr('');
    try {
      const data = await AdminAPI.leads({ page: 1, page_size: 100 });
      const arr = Array.isArray(data?.items) ? data.items : (Array.isArray(data) ? data : (data?.leads || []));
      setItems(arr);
    } catch(e) {
      setErr(e.message || 'Не удалось загрузить лиды');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(()=>{ load(); }, []);

  const loadDetail = async (id) => {
    if (!id) { setDetail(null); return; }
    setLoadingDetail(true);
    try {
      const data = await AdminAPI.getLead(id);
      setDetail(data?.lead || data || null);
    } catch(e) {
      alert(e.message || 'Не удалось загрузить детали лида');
      setDetail(null);
    } finally {
      setLoadingDetail(false);
    }
  };

  React.useEffect(() => {
    if (selectedId) loadDetail(selectedId);
    else setDetail(null);
  }, [selectedId]);

  const save = async (id, patch) => {
    try { await AdminAPI.updateLead(id, patch); await load(); if (selectedId === id) await loadDetail(id); }
    catch(e){ alert(e.message); }
  };

  const filtered = items.filter(l => {
    const okStatus = !status || l.status === status;
    const okType = !type
      ? true
      : (type === 'rent' || type === 'sell')
        ? l.type === 'sell-or-rent'
        : l.type === type;
    return okStatus && okType;
  });

  return (
    <>
      <Card>
        <h3>Лиды</h3>
        {err && <div style={{color:'#e66', marginBottom:8}}>{err}</div>}

        <Row3 style={{marginBottom:10}}>
          <Field>Статус
            <select value={status} onChange={e=>setStatus(e.target.value)}>
              <option value="">Все</option>
              <option value="new">Новый</option>
              <option value="in_progress">В работе</option>
              <option value="done">Завершён</option>
              <option value="rejected">Отклонён</option>
            </select>
          </Field>
          <Field>Тип
            <select value={type} onChange={e=>setType(e.target.value)}>
              <option value="">Все</option>
              <option value="consultation">Консультация</option>
              <option value="callback">Запрос контакта</option>
              <option value="rent">Сдача</option>
              <option value="sell">Продать</option>
            </select>
          </Field>
          <div style={{display:'flex', alignItems:'end', gap:10}}>
            <Btn onClick={()=>{ setStatus(''); setType(''); }}>Сброс</Btn>
            <Btn onClick={load}>Обновить</Btn>
          </div>
        </Row3>

        {loading ? <div>Загрузка…</div> : (
          <TableWrap>
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Дата</th>
                  <th>Вид запроса</th>
                  <th>Имя</th>
                  <th>Телефон</th>
                  <th>E-mail</th>
                  <th>Статус</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(l=>(
                  <tr key={l.id} style={{cursor: 'pointer'}} onClick={()=>setSelectedId(l.id)}>
                    <td><strong>#{l.id}</strong></td>
                    <td style={{fontSize:12, opacity:.8}}>{formatDate(l.created_at)}</td>
                    <td><span className="badge">{displayTypeLabel(l.type, type)}</span></td>
                    <td>{l.first_name || l.name || '—'}</td>
                    <td>{l.phone ? <a href={`tel:${l.phone}`} onClick={e=>e.stopPropagation()}>{l.phone}</a> : '—'}</td>
                    <td>{l.email ? <a href={`mailto:${l.email}`} onClick={e=>e.stopPropagation()}>{l.email}</a> : '—'}</td>
                    <td onClick={e=>e.stopPropagation()}>
                      <select value={l.status || 'new'} onChange={e=>save(l.id, { status: e.target.value })} style={{fontSize:13}}>
                        <option value="new">Новый</option>
                        <option value="in_progress">В работе</option>
                        <option value="done">Завершён</option>
                        <option value="rejected">Отклонён</option>
                      </select>
                    </td>
                    <td onClick={e=>e.stopPropagation()}>
                      <div style={{display:'flex', gap:6, flexWrap:'wrap'}}>
                        <Btn onClick={()=>setSelectedId(l.id)} style={{fontSize:12, padding:'6px 10px'}}>Подробнее</Btn>
                        <Btn onClick={()=>save(l.id, { pinned: !(l.pinned) })} style={{fontSize:12, padding:'6px 10px'}}>
                          {l.pinned ? '📌' : '📄'}
                        </Btn>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableWrap>
        )}
      </Card>

      {/* Модальное окно деталей лида */}
      {selectedId && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position:'fixed', inset:0, zIndex:4000, background:'rgba(0,0,0,.4)',
            display:'flex', alignItems:'center', justifyContent:'center', padding:18
          }}
          onClick={()=>setSelectedId(null)}
        >
          <Card
            style={{maxWidth:800, width:'100%', maxHeight:'90vh', overflow:'auto'}}
            onClick={(e)=>e.stopPropagation()}
          >
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14}}>
              <h3 style={{margin:0}}>Лид #{selectedId}</h3>
              <Btn onClick={()=>setSelectedId(null)}>✕</Btn>
            </div>

            {loadingDetail ? (
              <div style={{opacity:.7}}>Загрузка деталей…</div>
            ) : detail ? (
              <div style={{display:'grid', gap:14}}>
                <Row2>
                  <Field>
                    Вид лида
                    <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                      <strong>{displayTypeLabel(detail.type, type)}</strong>
                    </div>
                  </Field>
                  <Field>
                    Статус
                    <select value={detail.status || 'new'} onChange={e=>save(detail.id, { status: e.target.value })}>
                      <option value="new">Новый</option>
                      <option value="in_progress">В работе</option>
                      <option value="done">Завершён</option>
                      <option value="rejected">Отклонён</option>
                    </select>
                  </Field>
                </Row2>

                <Field>
                  Имя
                  <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                    {detail.first_name || detail.name || '—'}
                  </div>
                </Field>

                <Row2>
                  <Field>
                    Телефон
                    <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                      {detail.phone ? <a href={`tel:${detail.phone}`}>{detail.phone}</a> : '—'}
                    </div>
                  </Field>
                  <Field>
                    E-mail
                    <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                      {detail.email ? <a href={`mailto:${detail.email}`}>{detail.email}</a> : '—'}
                    </div>
                  </Field>
                </Row2>

                {detail.message && (
                  <Field>
                    Сообщение
                    <textarea
                      value={detail.message}
                      readOnly
                      rows={4}
                      style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10, resize:'vertical'}}
                    />
                  </Field>
                )}

                {(detail.region || detail.region_id) && (
                  <Field>
                    Регион
                    <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                      {detail.region?.name || detail.region?.name_ru || detail.region_id || '—'}
                    </div>
                  </Field>
                )}

                {(detail.district || detail.district_id) && (
                  <Field>
                    Район
                    <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                      {detail.district?.name || detail.district?.name_ru || detail.district_id || '—'}
                    </div>
                  </Field>
                )}

                {detail.source_page && (
                  <Field>
                    Страница источника
                    <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                      {detail.source_page}
                    </div>
                  </Field>
                )}

                {(detail.utm_source || detail.utm_medium || detail.utm_campaign) && (
                  <Row2>
                    {detail.utm_source && (
                      <Field>
                        UTM Source
                        <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10, fontSize:12}}>
                          {detail.utm_source}
                        </div>
                      </Field>
                    )}
                    {detail.utm_medium && (
                      <Field>
                        UTM Medium
                        <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10, fontSize:12}}>
                          {detail.utm_medium}
                        </div>
                      </Field>
                    )}
                  </Row2>
                )}

                {detail.assigned_to_user && (
                  <Field>
                    Назначен менеджеру
                    <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10}}>
                      {detail.assigned_to_user.first_name || detail.assigned_to_user.username || detail.assigned_to || '—'}
                    </div>
                  </Field>
                )}

                <Field>
                  Дата создания
                  <div style={{padding:'8px 12px', background:'var(--card)', border:'1px solid var(--bdr)', borderRadius:10, fontSize:12}}>
                    {formatDate(detail.created_at)}
                  </div>
                </Field>

                {detail.comment && (
                  <Field>
                    Комментарий
                    <textarea
                      value={detail.comment || ''}
                      onChange={e=>save(detail.id, { comment: e.target.value })}
                      rows={3}
                      placeholder="Добавьте комментарий..."
                    />
                  </Field>
                )}

                <div style={{display:'flex', gap:10, marginTop:8}}>
                  <Btn onClick={()=>save(detail.id, { pinned: !(detail.pinned) })}>
                    {detail.pinned ? '📌 Открепить' : '📄 Закрепить'}
                  </Btn>
                </div>
              </div>
            ) : (
              <div style={{color:'#e66'}}>Не удалось загрузить детали лида</div>
            )}
          </Card>
        </div>
      )}
    </>
  );
}
